// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/badge.ts
export const Badge = {
  baseStyle: {
    px: '0.25rem',
    fontSize: '0.625rem',
    borderRadius: '0.25rem',
  },
}
